import { render } from "./salaryNormal.vue?vue&type=template&id=4799fad0&scoped=true"
import script from "./salaryNormal.vue?vue&type=script&lang=js"
export * from "./salaryNormal.vue?vue&type=script&lang=js"

import "./salaryNormal.vue?vue&type=style&index=0&id=4799fad0&lang=scss&scoped=true"
import "./salaryNormal.vue?vue&type=style&index=1&id=4799fad0&lang=scss&scoped=true"
import "./salaryNormal.vue?vue&type=style&index=2&id=4799fad0&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4799fad0"]])

export default __exports__